const SAVED_POST_IDS_KEY = 'community.savedPostIds.v1';

export function loadSavedPostIds(): string[] {
  try {
    const raw = window.localStorage.getItem(SAVED_POST_IDS_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.filter((item) => typeof item === 'string');
    }
  } catch (error) {
    console.warn('Failed to load saved post ids', error);
  }
  return [];
}

export function persistSavedPostIds(ids: string[]): void {
  try {
    window.localStorage.setItem(SAVED_POST_IDS_KEY, JSON.stringify(ids));
  } catch (error) {
    console.warn('Failed to persist saved post ids', error);
  }
}
